import { Component, ElementRef, Input, OnInit, QueryList, ViewChild, ViewChildren } from "@angular/core";

/* import { GeneralComunicationService } from "src/app/services/general-comunication.service";
 *//* import { NotificationsPanelComponent } from "../controls/notifications-panel/notifications-panel.component";
 *//* import { StaticData } from "../../helpers/static-data";
 *//* import { Utilities } from "src/app/helpers/utilities"; */
import { Router } from "@angular/router";
import { DiagramComponent } from "../diagram/diagram.component";
import { BaseServiceService } from "src/app/services/base-service.service";
import { ModalNotifyTypes } from "../modal-notify/modal-notify.component";
/* import { BaseServiceService } from "../services/base-service.service";
 *//* import { CrudActions } from "../../models/general.enum";
 */
@Component({
  selector: 'app-optionsdiagram',
  templateUrl: './optionsdiagram.component.html',
  styleUrl: './optionsdiagram.component.css'
})
export class OptionsDiagramComponent {
  @ViewChild(DiagramComponent) diagramComponent: DiagramComponent;
  @ViewChild("fileInput") fileInput: ElementRef;

  diagramUrl =
  "https://cdn.statically.io/gh/AlvaroG1016/prueba-bpmn/main/newDiagram.bpmn";
  importError?: Error;
  archivoTabActivo: string | null = null; // Inicialmente, ningún menú está abierto

  constructor(private baseService : BaseServiceService){}

  handleImported(event) {
    const { type, error, warnings } = event;

    if (type === "success") {
      console.log(`Rendered diagram (%s warnings)`, warnings.length);
    }

    if (type === "error") {
      console.error("Failed to render diagram", error);
    }

    this.importError = error;
  }



  //LOgica Menu
  toggleTab(tab: string) {
    if (this.archivoTabActivo === tab) {
      this.archivoTabActivo = null; // Si la misma pestaña se hace clic de nuevo, cierra el menú
    } else {
      this.archivoTabActivo = tab; // Si se hace clic en una nueva pestaña, abre su menú y cierra el otro
    }
  }

  activateExportArtifacts() {
    try {
      this.baseService.descargarDiagramas();
    } catch (error) {
      this.baseService.triggerShowModal('Error descargando el archivo', error, ModalNotifyTypes.Danger, false)
    }
  }

  openFileInput() {
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const xml: string = reader.result.toString();
        this.baseService.importarFiagramas(xml);
      };
      reader.readAsText(file);
    }
  }

}
